/** Renders the server's saved follow-up and outcome, without selecting or scheduling respondents. */
import type { ShopifyResultInquiry } from '@testfeed/shopify-contracts'

type Conversation = NonNullable<ShopifyResultInquiry['conversations']>[number]

export function ServerInquiryConversation({ conversation }: { conversation: Conversation }) {
  return (
    <s-stack direction="block" gap="base">
      <s-text type="strong">{conversation.source}</s-text>
      <s-text>{conversation.statusLabel}</s-text>
      <WriterStatus label={conversation.writerStatusLabel} />
      <Followup followup={conversation.followup} />
      <OriginalAnswers conversation={conversation} />
    </s-stack>
  )
}

function WriterStatus({ label }: { label: string | null }) {
  if (!label) return null
  return <s-text color="subdued">{label}</s-text>
}

function Followup({ followup }: { followup: Conversation['followup'] }) {
  if (!followup) return null
  let answer = null
  if (followup.answer !== null)
    answer = (
      <s-stack direction="block" gap="small-200">
        <s-text color="subdued">{followup.answerLabel}</s-text>
        <s-paragraph>{followup.answer}</s-paragraph>
      </s-stack>
    )
  return (
    <s-stack direction="block" gap="base">
      <s-text color="subdued">{followup.questionLabel}</s-text>
      <s-paragraph>{followup.question}</s-paragraph>
      {answer}
    </s-stack>
  )
}

function OriginalAnswers({ conversation }: { conversation: Conversation }) {
  if (!conversation.originalAnswers.length) return null
  return (
    <details className="response-phrase-disclosure">
      <summary>{conversation.originalLabel}</summary>
      <s-stack direction="block" gap="base">
        {conversation.originalAnswers.map((answer) => (
          <s-stack direction="block" gap="small-200" key={answer.id}>
            <s-text type="strong">{answer.question}</s-text>
            <s-paragraph>{answer.response}</s-paragraph>
          </s-stack>
        ))}
      </s-stack>
    </details>
  )
}
